// src/data/books.js

export const books = [
  {
    id: 3,
    slug: 'loyalty-burns',
    title: 'Loyalty Burns',
    description: 'Trapped in Greece and hunted by the CIA, Sierra Justice must survive a war of power-hungry tech oligarchs and impossible choices—while her son races toward her deadliest secret.',
    synopsis: [
      "Global war rumbles like an approaching thunderhead.",
      "In Loyalty Burns, Volume III of the Sierra Justice Series, Sierra is trapped in Greece, immersed in subterfuge and pain. She must hold on long enough to escape. The CIA continues their hunt for Sierra and Revelation Six, but the machinations of Quantum Underground, a network of power-hungry tech oligarchs, threaten everyone. For Sierra, all roads converge in violence.",
      "Back home, Sierra's tween son, Ben, stumbles upon clues to his mother's secret identity. Confused and scared, he sets out on his own unauthorized and treacherous journey of discovery.",
      "When the US-led military operation targeting Quantum Underground hits Greek shores, Sierra questions everything. What will she decide?",
      "Secrets run deeper. Allegiances are tested.",
      "The death toll grows.",
      "Loyalty burns."
    ],
    keyPhrase: 'Secrets run deeper. Allegiances are tested. Loyalty burns.',
    details: {
      genre: 'Espionage Thriller',
      releaseDate: 'July 22, 2026',
      publisher: 'Falcon Mountain Publishing, LLC',
      isbn: '979-8992410358'
    },
    productDetails: [
      { label: 'ASIN', value: 'B0H9XNBDX6' },
      { label: 'Edition', value: '1st' },
      { label: 'Language', value: 'English' },
      { label: 'Print length', value: '337 pages' },
      { label: 'File size', value: '5.4 MB' },
      { label: 'Series', value: 'Book 3 of 3 · Sierra Justice Series' },
      { label: 'Enhanced typesetting', value: 'Enabled' },
      { label: 'Word Wise', value: 'Enabled' },
      { label: 'Screen Reader', value: 'Supported' },
      { label: 'X-Ray', value: 'Not Enabled' },
      { label: 'Page Flip', value: 'Enabled' },
      { label: 'Best Sellers Rank', value: '#3,316 in Terrorism Thrillers · #5,355 in Espionage Thrillers · #5,952 in Conspiracy Thrillers' }
    ],
    reviews: [
    ],
    coverUrl: '/assets/loyalty-burns-cover.webp',
    link: '/books/loyalty-burns',
    tags: [
      'Espionage Thriller', 'Spy Thriller', 'CIA', 'International Intrigue',
      'Conspiracy Thriller', 'Techno-Thriller', 'Tech Oligarchs', 'Female Protagonist',
      'Motherhood and Sacrifice', 'Secret Identity', 'Set in Greece', 'Global War',
      'Military Operation', 'High Stakes Drama', 'Action-Packed', 'Betrayal and Loyalty',
      'Survival at All Costs', 'Series Finale', 'Sierra Justice Series', 'Page Turner',
    ],
    rating: 0,
    retailers: [
      { name: 'Amazon', link: 'https://www.amazon.com/dp/B0H9XNBDX6', iconUrl: '/assets/retailers/amazon-icon.svg' },
    ],
    distributor: {
      name: '',
      link: ''
    }
  },
  {
    id: 1,
    slug: 'vengeance-collides',
    title: 'Vengeance Collides',
    description: 'Betrayed and ensnared by a deadly conspiracy, Sierra Justice must protect her son and stop a looming catastrophe in a world where no one can be trusted.',
    synopsis: [
      "In Vengeance Collides, the riveting sequel to Deceit Runs Red, Sierra Justice is stunned by the shocking betrayal of the ruthless assassin she once begrudgingly trusted. Ensnared deep within a covert operation of Revelation Six, the shadowy organization behind the explosive events in volume one, Sierra searches for an escape. Fueled by her need for revenge and desperate determination to protect her son Benny, Sierra’s only way out is through. But she’s not the only one with a vendetta.",
      "Caught in the crosshairs of an international cat-and-mouse, Sierra suspects nothing is as it seems. As a reluctant Rev Six recruit, she races to prevent a global catastrophe. As clandestine forces with concealed motives close in, the real question is whose time will run out first. No one can be trusted.",
      "Brutality reigns.",
      "Vengeance collides."
    ],
    keyPhrase: '',
    details: {
      genre: 'Legal Thriller',
      releaseDate: 'November 18, 2025',
      publisher: 'Falcon Mountain Publishing, LLC',
      isbn: ' 979-8992410334'
    },
    reviews: [
    ],
    coverUrl: '/assets/vengeance-collides-cover.webp',
    link: '/books/vengeance-collides',
    tags: [
      'Action Thriller', 'Legal Suspense', 'Female Protagonist', 'Motherhood and Sacrifice',
      'Revenge Story', 'Conspiracy Thriller', 'Assassin Betrayal', 'Shadowy Organizations',
      'International Intrigue', 'Cat-and-Mouse Tension', 'High Stakes Drama', 'Global Catastrophe',
      'Psychological Suspense', 'Fast-Paced Read', 'Character-Driven', 'Explosive Sequel',
      'Trust and Betrayal', 'Moral Dilemma', 'Survival at All Costs', 'Page Turner',
    ],
    rating: 0,
    retailers: [
      { name: 'Amazon', link: 'https://a.co/d/bCRaQ2R', iconUrl: '/assets/retailers/amazon-icon.svg' },
    ],
    distributor: {
      name: '',
      link: ''
    }
  },
  {
    id: 2,
    slug: 'deceit-runs-red',
    title: 'Deceit Runs Red',
    description: "A brilliant environmental attorney, a high-stakes conspiracy, and a choice that will change everything.",
    synopsis: [
      "Sierra Justice is a brilliant environmental attorney drowning in debt and haunted by her past. She has two dreams: a better life for her young son, Benny, and continuing her mother’s legacy of protecting the environment. Caught at a crossroads where one dream comes at the cost of the other, she must choose between remaining principled in poverty or unsettled in unbelievable wealth.",
      "She accepts a lucrative, yet reprehensible job offer from notorious billionaire developer, Wade Ford. A generous salary. Perks. A once-in-a-lifetime bonus for one year of her legal work on Ford’s controversial construction project deep in pristine Grand Canyon National Park.",
      "As the year draws to a close, a brutal mercenary sent by a clandestine organization sets a deadly plan in motion. As Sierra discovers the sinister truth she is forced once again to choose between her conscience and her child; only this time the stakes are far higher than financial security.",
      "Paths converge. Lies are exposed. Blood is spilled.",
      "Deceit Runs Red."
    ],

    keyPhrase: "Paths converge. Lies are exposed. Blood is spilled.",
    details: {
      genre: "Legal Thriller",
      releaseDate: "February 25, 2025",
      publisher: "Falcon Mountain Publishing, LLC",
      isbn: "979-8-9894103-0-5"
    },
    // --- UPDATED REVIEWS SECTION ---
    reviews: [
      { id: "review-1", name: "Lauren", review: "A great new series to sink your teeth into...Such a fun read with wit and humor..." },
      { id: "review-2", name: "Winter", review: "The writing draws you in from the beginning...definitely leaves you excited to see what happens next!" },
      { id: "review-3", name: "Andrea", review: "Amazing Novel...makes you feel like you're experiencing everything first hand." },
      { id: "review-4", name: "Roxi", review: "Fast paced and well written...I had a hard time putting my book down..." },
      { id: "review-5", name: "Barry", review: "Falkenberg delivered an innovative take on the genre...Character development is well done, layered..." }
    ],
    coverUrl: '/assets/deceit-cover-front.webp',
    link: '/books/deceit-runs-red',
    tags: [
      'Legal Thriller', 'Environmental Justice', 'Single Mother Heroine', 'Corporate Conspiracy',
      'Moral Dilemma', 'High Stakes Drama', 'Action-Packed', 'Slow Burn Suspense',
      'Crime Adventure', 'Psychological Tension', 'Corruption in Power', 'Character-Driven',
      'Ethical Conflict', 'Fast-Paced Read', 'Page Turner', 'First in Series',
      'Modern Legal Ethics', 'High-Risk Legal Deal', 'Maternal Sacrifice', 'Gripping Debut'
    ],
    rating: 4.8,
    retailers: [
      { name: 'Amazon', link: 'https://www.amazon.com/dp/B0DXL55ZVH?ref_=cm_sw_r_ffobk_cp_ud_dp_0QAC1SJ31R0RK1VMF2XN&bestFormat=true', iconUrl: '/assets/retailers/amazon-icon.svg' },
      { name: 'Barnes & Noble', link: 'https://www.barnesandnoble.com/w/deceit-runs-red-robert-falkenberg/1147576686', iconUrl: '/assets/retailers/amazon-icon.svg' },
    ],
    // --- NEWLY ADDED ---
    distributor: {
      name: 'IngramSpark',
      link: 'https://www.ingramspark.com/',
    }
  },
];